module.exports = __webpack_public_path__ + "img/face2.3d896e42.png";